import { gql } from 'apollo-boost'

import useMutation, { mutationTypes } from '@utils/graphqlUtils'

const MUTATION = gql`
  mutation(
    $data: PumpingSystemCreateInput!
  ) {
    createOnePumpingSystem(data: $data) {
      name
    }
  }
`

export default () => (
  useMutation(MUTATION, `Sistema de bombagem criado`, mutationTypes.CREATE)
)
